import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
const UpdateInvoiceItemController = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceItemController.url(args, options),
    method: 'put',
})

UpdateInvoiceItemController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
UpdateInvoiceItemController.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return UpdateInvoiceItemController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}'
*/
UpdateInvoiceItemController.put = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceItemController.url(args, options),
    method: 'put',
})

export default UpdateInvoiceItemController